import React from 'react';
import { clsx } from 'clsx';

export const Badge = ({ status, children, size = 'md', variant = 'default' }) => {
  const statusStyles = {
    'On Track': 'bg-green-50 text-green-700 border-green-200 ring-green-600/10',
    'Good': 'bg-green-50 text-green-700 border-green-200 ring-green-600/10',
    'At Risk': 'bg-amber-50 text-amber-700 border-amber-200 ring-amber-600/10',
    'Delayed': 'bg-red-50 text-red-700 border-red-200 ring-red-600/10',
    'Abandoned': 'bg-red-50 text-red-700 border-red-200 ring-red-600/10',
    'Debarment Alert': 'bg-slate-900 text-white border-slate-700',
    'Behind': 'bg-red-50 text-red-700 border-red-200 ring-red-600/10',
    'Completed': 'bg-blue-50 text-blue-700 border-blue-200 ring-blue-600/10',
    'Critical': 'bg-red-50 text-red-700 border-red-200 ring-red-600/10',
    'Overdue': 'bg-red-50 text-red-700 border-red-200 ring-red-600/10',
    'Warning': 'bg-amber-50 text-amber-700 border-amber-200 ring-amber-600/10',
    'Pending': 'bg-slate-50 text-slate-700 border-slate-200 ring-slate-600/10',
    'Published': 'bg-green-50 text-green-700 border-green-200 ring-green-600/10',
    'Draft': 'bg-amber-50 text-amber-700 border-amber-200 ring-amber-600/10',
    'Confidential': 'bg-red-50 text-red-700 border-red-200 ring-red-600/10',
    'In Progress': 'bg-blue-50 text-blue-700 border-blue-200 ring-blue-600/10',
    'Stalled': 'bg-slate-50 text-slate-700 border-slate-200 ring-slate-600/10',
    'Blocked': 'bg-red-50 text-red-700 border-red-200 ring-red-600/10',
    'Implemented': 'bg-green-50 text-green-700 border-green-200 ring-green-600/10'
  };

  const sizes = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm'
  };

  return (
    <span
      className={clsx(
        "inline-flex items-center justify-center font-medium rounded-md border ring-1 ring-inset",
        statusStyles[status] || 'bg-slate-50 text-slate-700 border-slate-200 ring-slate-600/10',
        sizes[size]
      )}
    >
      {children || status}
    </span>
  );
};